import Vue from 'vue'
import submissionStore from 'store/submission-store'
import standalonePopoverLoader from 'widgets/standalone-popover/standalone-popover-loader'
import Modal from 'objects/modal/modal'
import WarnCloseModal from 'components/warn-close-modal/warn-close-modal'

import withRender from './submission-modal.html'
import './submission-modal.scss'

export default withRender(Vue.extend({
  name: 'SubmissionModal',
  data() {
    return {
      isConfirmOpen: false,
      isFormLoaded: false,
      popoverMessage: '',
      popoverType: '',
      preventClickOutside: false,
      submissionStore
    }
  },
  components: {
    'tt-modal': Modal,
    // tslint:disable-next-line
    'tt-submission-mediator': () => import(/* webpackChunkName: 'submission' */ 'widgets/submission/submission-mediator'),
    'tt-warn-close-modal': WarnCloseModal
  },
  computed: {
    isOpen() {
      return this.submissionStore.isOpen
    },
    poweredByText() {
      return this.submissionStore.poweredByText
    }
  },
  methods: {
    closeConfirm() {
      this.isConfirmOpen = false
      this.$nextTick(() => this.$el.focus())
    },
    closePopover() {
      this.popoverMessage = ''
    },
    closeSubmissionModal() {
      this.isConfirmOpen = false
      submissionStore.fireBackEvent()
    },
    pageLoaded(preventClickOutside = false) {
      this.isFormLoaded = true
      this.preventClickOutside = preventClickOutside
    },
    pageLoading() {
      this.isFormLoaded = false
    },
    onShowError(providedMessage, closeModal = false, autoClosePopup = true) {
      if (closeModal) {
        const message = providedMessage || this.$msg('flowError.2000')
        standalonePopoverLoader.load({ message, type: 'error' , autoClose: autoClosePopup })
        this.closeSubmissionModal()
        return
      }
      this.popoverMessage = providedMessage
      this.popoverType = 'error'
    },
    onShowPopoverMessage(message, closeModal = false) {
      if (closeModal) {
        standalonePopoverLoader.load({ message })
        this.closeSubmissionModal()
        return
      }
      this.popoverMessage = message
      this.popoverType = 'success'
    },
    outsideClick() {
      if (this.preventClickOutside) {
        this.isConfirmOpen = true
        return
      }
      this.closeSubmissionModal()
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/widgets/submission/submission-modal.ts